import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class LoadingDrivebService {
  private _show$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  private _auto$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private _urlMap: Map<string, boolean> = new Map<string, boolean>();

  get auto$(): Observable<boolean> {
    return this._auto$.asObservable();
  }

  get show$(): Observable<boolean> {
    return this._show$.asObservable();
  }

  show(): void {
    this._show$.next(true);
  }

  hide(): void {
    this._show$.next(false);
  }

  setAutoMode(value: boolean): void {
    this._auto$.next(value);
  }

  _setLoadingStatus(status: boolean, url: string): void {
    // Return if the url was not provided
    if (!url) {
      console.error("The request URL must be provided!");
      return;
    }

    if (status) {
      this._urlMap.set(url, status);
      this._show$.next(true);
    } else if (!status && this._urlMap.has(url)) {
      this._urlMap.delete(url);
    }

    // Only set the status to 'false' if all outgoing requests are completed
    if (this._urlMap.size === 0) {
      this._show$.next(false);
    }
  }
}
